import { defineMessages } from 'react-intl';

const scope = 'cb.screens.Referrals';

export default defineMessages({
  expiresBadge: {
    id: `${scope}.expiresBadge`,
    defaultMessage: 'Expires: {date, date, ::dMMMyyyy}',
  },
  emptyTitle: {
    id: `${scope}.emptyTitle`,
    defaultMessage: 'No referrals yet',
  },
  emptyText: {
    id: `${scope}.emptyText`,
    defaultMessage: 'People you refer will show up here once they join.',
  },
  backToAccount: {
    id: `${scope}.backToAccount`,
    defaultMessage: 'Back to My Account',
  },
});